import { render } from "./Score.vue?vue&type=template&id=6bd92724&scoped=true"
import script from "./Score.vue?vue&type=script&lang=js"
export * from "./Score.vue?vue&type=script&lang=js"

import "./Score.vue?vue&type=style&index=0&id=6bd92724&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-6bd92724"

export default script